const spacing = {
  px: {
    xs: '5px',
    sm: '10px',
    norm: '16px',
    md: '30px',
    lg: '50px'
  },
  xs: 5,
  sm: 10,
  norm: 16,
  md: 30,
  lg: 50
};

export default spacing;
